import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { FaHandHoldingUsd } from "react-icons/fa";
import ModuleLayout from "../../layout/ModuleLayout";
import ZakatCalculatorPage from "../Zakat/ZakatCalculatorPage";

const ZakatModule = () => {
    const moduleConfig = {
        id: "zakat",
        title: "Zakat",
        description: "Calcul zakat base sur les donnees de l'application",
        icon: FaHandHoldingUsd,
        color: "#198754",
        menuItems: [
            { path: "/zakat-module/calculator", icon: FaHandHoldingUsd, label: "Calculateur" },
        ],
    };

    return (
        <ModuleLayout moduleConfig={moduleConfig}>
            <Routes>
                <Route path="/" element={<Navigate to="/zakat-module/calculator" replace />} />
                <Route path="/calculator" element={<ZakatCalculatorPage />} />
            </Routes>
        </ModuleLayout>
    );
};

export default ZakatModule;
